// LicensesList.js
import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from '@mui/material';
import './LicensesList.css';
import { CheckBox, CheckBoxOutlineBlank, RadioButtonChecked, RadioButtonUnchecked, Visibility } from '@mui/icons-material';

const LicensesList = ({ licenses, onSelectLicense }) => {
    return (
        <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
                <TableHead className="licenses-table-head">
                    <TableRow className="licenses-header-row">
                        <TableCell align="center" className='licenses-header-cell'></TableCell>
                        <TableCell align="center" className='licenses-header-cell'>License Code</TableCell>
                        <TableCell align="center" className='licenses-header-cell'>#Products</TableCell>
                        <TableCell align="center" className='licenses-header-cell'>Start Date</TableCell>
                        <TableCell align="center" className='licenses-header-cell'>End Date</TableCell>
                        <TableCell align="center" className='licenses-header-cell'>Active?</TableCell>
                        <TableCell align="center" className='licenses-header-cell'>Enabled?</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody className='licenses-table-body'>
                    {licenses.map((license) => (
                        <TableRow key={license.licenseId} className='licenses-table-row'>
                            <TableCell align="center" className="licenses-table-cell">
                                <IconButton onClick={() => onSelectLicense(license)}>
                                    <Visibility className="icon" />
                                </IconButton>
                            </TableCell>
                            <TableCell align="center" component="th" scope="row" className="licenses-table-cell">
                                {license.licenseCode}
                            </TableCell>
                            <TableCell align="center" className="licenses-table-cell">{license.products.length}</TableCell>
                            <TableCell align="center" className="licenses-table-cell">{new Date(license.startDate).toLocaleDateString()}</TableCell>
                            <TableCell align="center" className="licenses-table-cell">{new Date(license.endDate).toLocaleDateString()}</TableCell>
                            <TableCell align="center" className="licenses-table-cell">{license.active ? <RadioButtonChecked className='radio-button-checked' /> : <RadioButtonUnchecked className='radio-button-unchecked' />}</TableCell>
                            <TableCell align="center" className="licenses-table-cell">{license.enabled ? <CheckBox className='check-box' /> : <CheckBoxOutlineBlank className='check-box-outlined' />}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default LicensesList;